// Маршруты, на которых показываем полноэкранную заставку story_new до загрузки контента:
// корневой лэндинг и витрина магазина. На /auth заставка не нужна.
export const isSplashPath = (pathname: string): boolean => {
  if (pathname === "/auth" || pathname.startsWith("/auth/")) return false
  if (pathname === "/") return true
  if (pathname === "/store" || pathname.startsWith("/store/")) return true
  return false
}
